import React, { useState } from 'react';
import ProfessionalSummary from '../ProfessionalSummary/ProfessionalSummary';
import TabNavigation from '../TabNavigation/TabNavigation';
import TabContent from '../TabContent/TabContent';
import './MainContent.scss';

const MainContent = () => {
	const [activeTab, setActiveTab] = useState('overview');

	return (
		<main className="main-content">
			<div className="main-content__container">
				<ProfessionalSummary />
				<TabNavigation
					activeTab={activeTab}
					onTabChange={setActiveTab}
				/>
				<TabContent activeTab={activeTab} />
			</div>
		</main>
	);
};

export default MainContent;
